// marginx `?` keyboard-shortcuts cheat-sheet. Self-contained (inline styles, no
// BaseModal dependency); renders the shared ShortcutsList + a link to the page.
import { Link } from "react-router-dom";
import { useKeyboardContext } from "keyboard/useKeyboard";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { ShortcutsList, Kbd } from "./ShortcutsList";

export function ShortcutsModal() {
  const { shortcutsOpen, setShortcutsOpen } = useKeyboardContext();
  if (!shortcutsOpen) return null;

  return (
    <div
      onClick={() => setShortcutsOpen(false)}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483000,
        background: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 680,
          maxHeight: "80vh",
          overflowY: "auto",
          background: BACKGROUND_COLORS.eight,
          border: `1px solid ${BORDER_COLORS.three}`,
          borderRadius: 12,
          padding: 24,
          color: TEXT_COLORS.one,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <span style={{ fontSize: 16, fontWeight: 600, color: TEXT_COLORS.one }}>Keyboard shortcuts</span>
          <button
            onClick={() => setShortcutsOpen(false)}
            style={{ background: "transparent", border: "none", color: TEXT_COLORS.two, cursor: "pointer", fontSize: 18 }}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <ShortcutsList />
        <p style={{ marginTop: 16, paddingTop: 12, borderTop: `1px solid ${BORDER_COLORS.three}`, fontSize: 12, color: TEXT_COLORS.three, display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
          Press <Kbd>?</Kbd> to toggle · <Kbd>Esc</Kbd> to close · chords configure the order form.
          <Link to="/shortcuts" onClick={() => setShortcutsOpen(false)} style={{ marginLeft: "auto", color: COLORS.highlight.one }}>
            View full page →
          </Link>
        </p>
      </div>
    </div>
  );
}
